import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';
import FieldEditorContext from '../../providers/FieldEditor/FieldEditor.context';
import FieldPalette from '../FieldPalette';
import FieldSettings from '../FieldSettings';

import './EditorBottomSheet.styles.scss';

type EditorBottomSheetProps = {
  className?: string;
  header?: ReactNode;
  isPaletteDisabled?: boolean;
};

const EditorBottomSheet: React.FC<EditorBottomSheetProps> = (props) => {
  const { className, header, isPaletteDisabled } = props;

  const { selectedField } = useContext(FieldEditorContext);

  const classes = classNames('editor-bottom-sheet', className);

  return (
    <div className={classes}>
      {selectedField ? (
        <FieldSettings key={selectedField.id} field={selectedField} />
      ) : (
        <>
          {header}
          <FieldPalette isDisabled={isPaletteDisabled} />
        </>
      )}
    </div>
  );
};

export default EditorBottomSheet;
